var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook-square_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h16a4 4 0 014 4v16a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.593 15.781l.532-3.469h-3.328v-2.25c0-.948.465-1.874 1.955-1.874h1.514V5.233S15.892 5 14.58 5c-2.742 0-4.533 1.661-4.533 4.669v2.643H7v3.47h3.047v8.385a12.13 12.13 0 003.75 0V15.78h2.796z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook-square_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 014-4h16a4 4 0 014 4v16a4 4 0 01-4 4H4a4 4 0 01-4-4V4z",
    fill: "#fff"
  })))));
}

export default SvgFacebookSquare;